(function ($) {
  $(function () {
    var $navigation = $('.navigation');

    if ($navigation.length) {
      var navigation = (function () {
        var $navItems = $navigation.find('.nav-item');
        var $navToggleBtn = $navigation.find('.hamburger');
        var $navMenu = $navigation.find('nav');
        var $arrowBtn = $('.navigation .nav-item > .nav-item__wrapper');
        var $ernestPlusBackBtn = $('.navigation .nav-item .megamenu__title .back-arrow-btn');
        var $backBtn = $('.navigation .nav-item .megamenu__title h5 strong');
        var $navSearchBtn = $navigation.find('.search-btn');
        var $globalSearchOverlay = $('.global-search');
        var $backdrop = $('.global-search .backdrop');
        var $globalSearchCloseBtn = $('.global-search .close-button');
        var $searchBoxInput = $globalSearchOverlay.find('.search-box input[type="search"]');
        var $searchBoxResetBtn = $globalSearchOverlay.find('.search-box button[type="reset"]');
        var $stickyNav = $('.sticky-nav');
        var $tabpanel = $navigation.find('.tabpanel');
        var $tabpanelItems = $('.tabpanel .tabpanel__item');
        var $tabPanes = $('.tabpanel__content .tab-pane');
        var $tabPanesMobile = $('.tab-pane--mobile');
        var prevScrollPos = $(window).scrollTop();
        var hashAnchor = $('header .megamenu a[href*="#"]:not([href="#"]):not([href="#0"])');
        var $subscribeBtn = $('a[href="#subscribe"]');

        var initMenu = function () {
          $navigation.find('.megamenu__dropdown').removeClass('megamenu--open');
          $navigation.removeClass('mobile-menu--active');
          $arrowBtn.removeClass('open');
          $navToggleBtn.removeClass('active');
          $navMenu.removeAttr('style');
          $navMenu.removeClass('mobile-nav--active');
          $navItems.removeClass('active');

          if ($(window).width() < 1024) {
            $navigation.find('.megamenu__dropdown').removeAttr('style');
          }

          if ($(document).scrollTop() > 10) {
            $navigation.addClass('solid-bg');
          }

          inItInnerTab();
        };

        var toggleMegaMenuMobile = function (e) {
          e.stopPropagation();

          $(this)
            .closest('.nav-item')
            .siblings()
            .find('.megamenu__dropdown.megamenu--open')
            .removeClass('megamenu--open');
          $(this).closest('.nav-item').siblings().removeClass('active');
          $(this).closest('.nav-item').addClass('active');
          $(this).closest('.nav-item').siblings().find('.nav-item__wrapper.open').removeClass('open');
          $(this).toggleClass('open');
          $(this).closest('.nav-item').find('.megamenu__dropdown').toggleClass('megamenu--open');
        };

        var addIdOnTabpanelItems = function () {
          $tabpanelItems.each(function (i) {
            $(this).attr('data-list-id', 'tab-' + (i + 1));
          });
          $tabPanes.each(function (i) {
            $(this).attr('data-tab-id', 'tab-' + (i + 1));
          });
        };

        var inItInnerTab = function () {
          $tabpanelItems.removeClass('active');
          $tabpanelItems.eq(0).addClass('active');
          $('.navigation .action .tabpanel__item').eq(0).addClass('active');
          $tabPanes.eq(0).addClass('tab-pane--open');
          $tabPanesMobile.removeClass('tab-pane-mobile--open');

          if ($(window).width() < 768) {
            $tabpanelItems.removeClass('active');
          }
        };

        var innerTabHandler = function (e) {
          if ($tabpanel.length) {
            if ($(window).width() > 767) {
              e.preventDefault();
            }

            var tabId = $(this).attr('data-list-id');
            $tabpanelItems.removeClass('active');
            $(this).addClass('active');
            $tabPanes.removeClass('tab-pane--open');
            $(this)
              .closest('.megamenu__items')
              .find('.tab-pane[data-tab-id=' + tabId + ']')
              .addClass('tab-pane--open');
          }
        };

        var toggleNav = function (e) {
          e.stopPropagation();

          if ($navToggleBtn.hasClass('active')) {
            $navMenu.removeClass('mobile-nav--active');
            $navToggleBtn.removeClass('active');
            $('.navigation').removeClass('mobile-menu--active');
            $navItems.removeClass('active-nav').find('.megamenu__dropdown').removeClass('megamenu--open');
            initMenu();
          } else {
            $navToggleBtn.addClass('active');
            $navToggleBtn.closest('.navigation').addClass('mobile-menu--active');
            $navMenu.addClass('mobile-nav--active');
          }
        };

        var handleInputResetBtn = function(e) {
          if ($(this).val().length > 0) {
            $(this).closest('.search-box').find('.search-box__reset').show();
          } else {
            $(this).closest('.search-box').find('.search-box__reset').hide();
          }
        }

        var handleSubscribeBtnClick = function (e) {
          if ($('#subscribe').length) {
            e.preventDefault();

            smoothScrollToSubscribeForm($('#subscribe'));
          }
        }

        var hideResetBtn = function () {
          $(this).hide();
        }

        var openSearchOverlay = function (e) {
          e.stopPropagation();
          $globalSearchOverlay.fadeIn();
          $globalSearchOverlay.addClass('global-search--active');
        };

        var closeSearchOverlay = function (e) {
          e.stopPropagation();
          $globalSearchOverlay.fadeOut();
          $globalSearchOverlay.removeClass('global-search--active');
        };

        var preventSpace = function (e) {
          if (this.value.length === 0 && e.which === 32) {
            e.preventDefault();
          }
        };
        
        var preventSpecialCharacter = function (e) {
          if ((this.value.length > 0  || this.value.length === 0 )&& (!e.key.match(/^[a-zA-Z0-9\s]+$/))) {
            e.preventDefault();
          }
        }

        var preventItemsOnKeydown = function (e) {
          preventSpace.call(this, e);
          preventSpecialCharacter.call(this, e);
        }

        var mobileMegamenuHandler = function (e) {
          e.stopPropagation();

          $(this).closest('.megamenu').removeClass('megamenu--open');
          $(this).closest('.nav-item').removeClass('active');
          $(this).closest('.nav-item').find('.nav-item__wrapper').removeClass('open');
        };

        var addActiveClassOnPageNavItem = function () {
          var path = window.location.pathname;
          var lastChar = path.charAt(path.length - 1);
          var url;

          if (lastChar == '/') {
            url = path.slice(0, -1);
          }
          $('header nav ul .nav-item >a[href="' + url + '"]')
            .parent()
            .addClass('active-menu');
        };

        var handleDualNav = function () {
          if ($navigation.hasClass('dual-nav')) {
            $navigation.addClass('hide-main-nav');
            $('body').addClass('ernest-plus-nav');
          }
        };

        var getMainNavHeight = function () {
          return $navigation.find(".main-nav").outerHeight();
        }

        var getStickyNavHeight = function () {
          return $stickyNav.length ? $stickyNav.outerHeight() : 0;
        }

        var getAnchorOffsetTop =function (anchor) {
          var $anchor = $(anchor);

          if ($anchor.length) {
            return $anchor.offset().top;
          }
        }

        var smoothScrollTo = function (el) {
          var currentScrollPos = $(window).scrollTop();
          var anchorOffsetTop = getAnchorOffsetTop(el);
          var scrollTopPos = anchorOffsetTop - (getStickyNavHeight() + getMainNavHeight() + 1);

          if (currentScrollPos < anchorOffsetTop) {
            if ($(window).width() > 1023) {
              scrollTopPos = anchorOffsetTop - (getStickyNavHeight() + 1);
            } 
          }

          $("html, body").animate(
            {
              scrollTop: scrollTopPos,
            },
            700
          );
        }

        var smoothScrollToSubscribeForm = function (el) {
          var currentScrollPos = $(window).scrollTop();
          var anchorOffsetTop = getAnchorOffsetTop(el);
          var scrollTopPos;

          if (currentScrollPos < anchorOffsetTop) {
            if ($(window).width() > 1023) {
              scrollTopPos = anchorOffsetTop - ($('header').find('.main-nav').outerHeight()) - 100;
            } else {
              scrollTopPos = anchorOffsetTop - ($('header').find('.main-nav').outerHeight()) - 100;
            }
          } else {
            scrollTopPos = anchorOffsetTop - ($('header').find('.main-nav').outerHeight()) - 100;
          }

          $('html, body').animate(
            {
              scrollTop: scrollTopPos
            },
            700
          );
        }

        var handleHashAnchorClick = function () {
          $navMenu.removeClass('mobile-nav--active');
          $navToggleBtn.removeClass('active');
          $('header .megamenu__dropdown').removeClass('megamenu--open');
          $arrowBtn.removeClass('open');
          $('.nav-item.active').removeClass('active');

          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = jQuery(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            
            if (target.length) {
              smoothScrollTo(target);
              return false;
            }
          }
        }

        var removeAnimationLine = function () {
          if ($(window).width() > 1023) {
            $(this).closest('.nav-item').addClass('no-line');
          }
        }

        var triggerScroll = function () {
          var currentScrollPos = $(window).scrollTop();
          if (
            currentScrollPos > prevScrollPos &&
            currentScrollPos > $('header .main-nav').outerHeight() / 2
          ) {
            // Scrolling down
            $navigation.addClass('hide-nav');
            $('body').addClass('scrolling-down').removeClass('scrolling-up');
          } else if (currentScrollPos < prevScrollPos) {
            // Scrolling up
            $navigation.removeClass('hide-nav hide-main-nav');
            $('body').addClass('scrolling-up').removeClass('scrolling-down');
          }

          if ((currentScrollPos) => 10) {
            $navigation.addClass('solid-bg');
          }

          if (currentScrollPos <= 10) {
            $navigation.removeClass('solid-bg');
          }

          prevScrollPos = $(document).scrollTop();
        }

        return {
          init: function () {
            addIdOnTabpanelItems();
            inItInnerTab();
            addActiveClassOnPageNavItem();
            handleDualNav();
            this.bindEvents();
          },
          bindEvents: function () {
            $navToggleBtn.on('click', toggleNav);
            $arrowBtn.on('click', toggleMegaMenuMobile);
            $navSearchBtn.on('click', openSearchOverlay);
            $searchBoxInput.on('keydown', preventItemsOnKeydown);
            $searchBoxInput.on('input', handleInputResetBtn);
            $searchBoxResetBtn.on('click', hideResetBtn);
            $globalSearchCloseBtn.on('click', closeSearchOverlay);
            $backdrop.on('click', closeSearchOverlay);
            $tabpanelItems.on('click', innerTabHandler);
            $backBtn.on('click', mobileMegamenuHandler);
            $ernestPlusBackBtn.on('click', mobileMegamenuHandler);
            $(window).on('orientationchange resize load', initMenu);
            hashAnchor.on('click', handleHashAnchorClick);
            $(window).on('scroll', triggerScroll);
            $('.nav-item__wrapper >a').on('click', removeAnimationLine);
            $subscribeBtn.on('click', handleSubscribeBtnClick);
          }
        };
      })();

      navigation.init();
    }
  });
})(jQuery);

function gtag_report_conversion(url) {
  console.log('gtag')
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-745124762/TDJDCOie85YZEJrnpuMC',
      'event_callback': callback
  });
  return false;
}
let lets_tak_nav = document.querySelector('.lets-talk-btn')

if (lets_tak_nav){
  lets_tak_nav.addEventListener('click',(e)=>{
    gtag_report_conversion('/letstalk')

  })
}